import { PostCountObj } from "utils/types/general.types";
import SVG from "../core/SVG";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import RestoreFromTrashIcon from "@mui/icons-material/RestoreFromTrash";
import ConfirmDeleteModal from "../core/ConfirmDeleteModal";
import { useState } from "react";

export type SocialCountProps = {
    counts: PostCountObj;
    postId: string;
    isDeleted?: boolean;
};

const SocialCount = ({
    counts,
    postId,
    isDeleted = false
}: SocialCountProps) => {
    const deletePost = () => {
        console.log("delete post: ", postId);
    };

    const [open, setOpen] = useState(false);

    return (
        <>
            <div className="social-count flex justify-between items-center w-full md:px-5">
                <div className="likes-count  z-2 relative">
                    <div className="tool-tip-parent">
                        <div className="social-count-tooltip momeento-p">
                            Likes
                        </div>
                        {/* <SVG svg="heart" size={18} /> */}
                        <FavoriteBorderOutlinedIcon
                            className="dark:text-white"
                            fontSize="small"
                        />
                    </div>
                    <p className="momeento-p white-text">{counts.likes}</p>
                </div>

                <div className="likes-count  z-2 relative">
                    <div className="tool-tip-parent">
                        <div className="social-count-tooltip momeento-p">
                            Comments
                        </div>
                        <SVG
                            svg="message-circle"
                            size={18}
                            className="cursor-default"
                        />
                    </div>
                    <p className="momeento-p white-text">{counts.comments}</p>
                </div>

                <div className="likes-count  z-2 relative">
                    <div className="tool-tip-parent">
                        <div className="social-count-tooltip momeento-p">
                            Repost
                        </div>
                        <SVG
                            svg="repeat"
                            size={18}
                            className="cursor-default"
                        />
                    </div>
                    <p className="momeento-p white-text">{counts.reposts}</p>
                </div>

                <div className="likes-count  z-2 relative">
                    <div className="tool-tip-parent">
                        <div className="social-count-tooltip momeento-p">
                            Views
                        </div>
                        <VisibilityOutlinedIcon
                            className="dark:text-white"
                            fontSize="small"
                        />
                    </div>
                    <p className="momeento-p white-text">
                        {counts.views || "NaN"}
                    </p>
                </div>

                <div className="likes-count  z-2 relative">
                    {isDeleted ? (
                        <div className="tool-tip-parent">
                            <div className="social-count-tooltip momeento-p">
                                Restore
                            </div>
                            <div>
                                <RestoreFromTrashIcon
                                    fontSize="small"
                                    className="dark:text-white cursor-pointer"
                                />
                            </div>
                        </div>
                    ) : (
                        <div className="tool-tip-parent">
                            <div className="social-count-tooltip momeento-p">
                                Delete
                            </div>
                            <div onClick={() => setOpen(true)}>
                                <SVG svg="trash" size={18} />
                            </div>
                        </div>
                    )}
                    {/* <p className="momeento-p white-text">{postId}</p> */}
                </div>
            </div>
            <ConfirmDeleteModal
                open={open}
                setOpen={setOpen}
                text="Delete Post/Incident"
                handleDelete={deletePost}
            />
        </>
    );
};

export default SocialCount;
